import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const ArrowDownIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <path
        id="icon"
        d="M11 14.2V6C11 5.71667 11.0958 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6V14.2L15.9 11.3C16.0833 11.1167 16.3167 11.025 16.6 11.025C16.8833 11.025 17.1167 11.1167 17.3 11.3C17.4833 11.4833 17.575 11.7167 17.575 12C17.575 12.2833 17.4833 12.5167 17.3 12.7L12.7 17.3C12.5 17.5 12.2667 17.6 12 17.6C11.7333 17.6 11.5 17.5 11.3 17.3L6.69999 12.7C6.51665 12.5167 6.42499 12.2833 6.42499 12C6.42499 11.7167 6.51665 11.4833 6.69999 11.3C6.88332 11.1167 7.11665 11.025 7.39999 11.025C7.68332 11.025 7.91665 11.1167 8.09999 11.3L11 14.2Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowDownIcon;